import React, { useState } from 'react';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { DATE_FORMAT } from '../../../utils/styleUtils';
import { SxProps, TextField, TextFieldProps, Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

interface IProps {
  id: string;
  label: string;
  value: Date | null;
  onChange: (value: Date | null, keyboardInputValue?: string | undefined) => void;
  sx?: SxProps<Theme>;
  minDate?: Date;
  maxDate?: Date;
  errorMsg?: string | null;
  disabled?: boolean;
  views?: Array<'day' | 'month' | 'year'>;
  format?: string;
  isWhite?: boolean;
  hideEndIcon?: boolean;
  clearable?: boolean;
}

const EpraDatePicker: React.FunctionComponent<IProps> = ({
  id,
  label,
  value,
  onChange,
  sx,
  minDate,
  maxDate,
  errorMsg,
  disabled = false,
  views,
  format = DATE_FORMAT,
  isWhite,
  hideEndIcon = false,
  clearable = false
}) => {
  const [open, setOpen] = useState(false);
  const getParams = (params: TextFieldProps) => {
    if (hideEndIcon) {
      return { ...params.InputProps, endAdornment: '' };
    }
    return { ...params.InputProps };
  };

  return (
    <DesktopDatePicker
      label={label}
      inputFormat={format}
      value={value}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={onChange}
      disabled={disabled}
      InputAdornmentProps={{
        sx: {
          marginLeft: 0,
          '& button': {
            marginRight: 0
          }
        }
      }}
      {...(clearable && {
        componentsProps: {
          actionBar: {
            actions: ['clear']
          }
        }
      })}
      minDate={minDate}
      maxDate={maxDate}
      views={views}
      renderInput={(params) => (
        <TextField
          {...params}
          id={id}
          disabled={disabled}
          {...(errorMsg !== undefined && {
            error: errorMsg !== null,
            helperText: errorMsg ?? '',
            required: true
          })}
          sx={{
            color: errorMsg !== undefined && errorMsg !== null ? Colors.red : Colors.main,
            backgroundColor: isWhite ? 'white' : Colors.input_field_background,
            height: '36px',
            borderRadius: '9px',
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: 'none'
              }
            },
            ...sx
          }}
          InputProps={{
            ...getParams(params),
            sx: { paddingRight: 0, position: 'relative' }
          }}
          FormHelperTextProps={{
            sx: {
              marginX: 0
            }
          }}
          InputLabelProps={{
            shrink: true,
            sx: {
              lineHeight: '22px',
              top: '-9px',
              color: errorMsg !== undefined && errorMsg !== null ? Colors.red : Colors.main
            }
          }}
          inputProps={{
            ...params.inputProps,
            sx: {
              height: '36px',
              paddingLeft: '15px',
              paddingY: 0,
              color: errorMsg !== undefined && errorMsg !== null ? Colors.red : Colors.main
            }
          }}
          onClick={() => {
            if (!disabled) setOpen(true);
          }}
        />
      )}
    />
  );
};

export default EpraDatePicker;
